export default __webpack_public_path__ + "static/media/mode-45.a80d53b0.svg";